<template>
  <div class="content progress-query">
    <div v-if="this.$hasConstruction('IEBDC:SY:XXCX:JDCX:SFZJ')">
      <div class="form-content">
        <div class="tip">
          <span>证书核验</span>
        </div>
        <el-form label-width="150px" :model="formData" :rules="rules" ref="form">
          <el-row>
            <el-col :span="20">
              <el-form-item label="不动产坐落" :rules="[vrules.required]">
                <zl-directives v-model="zlData" :zlConfig="zlConfig"></zl-directives>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="15">
              <el-form-item label="不动产权证号" prop="bdcqzh">
                <el-input v-model="formData.bdcqzh" placeholder="请输入不动产权证号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="权利人证件号" prop="zjh">
                <el-input v-model="formData.zjh" placeholder="请输入证件号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="证书编号" prop="ysxlh">
                <el-input v-model="formData.ysxlh" placeholder="请输入证书编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="20px">
                <el-button type="primary" @click="submit">核验</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="4" v-show="singleImgUrl">
              <el-image style="width: 50px; height: 50px;" fit="fill" :src="singleImgUrl"></el-image>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import vrules from '@/utils/validate.js';
import { verifyBdcqzh } from '@/pages/iebdc/api/progress-query-service.js';
import { mapGetters } from 'vuex';
import { localDataUser } from '@iebdc/utils/local-data';

export default {
  name: 'licenseVerify',
  data() {
    this.rules = {
      bdcqzh: [{ required: true, message: '请输入不动产权证号', trigger: 'blur' }],
      zjh: [{ required: true, message: '请输入证件号', trigger: 'blur' }],
      ysxlh: [{ required: true, message: '请输入证书编号', trigger: 'blur' }]
    };
    return {
      user: localDataUser.get(),
      vrules: vrules,
      zlConfig: {
        zlKey: 'code',
        rules: [],
        hideZl: true,
        disabled: false
      },
      zlData: {
        zlProvince: '',
        zlCity: '',
        zlArea: ''
      },
      formData: {
        bdcqzh: '',
        zjh: '',
        ysxlh: ''
      },
      singleImgUrl: null,
      successImg: require('@/pages/iebdc/assets/images/gayz-success.png'),
      failImg: require('@/pages/iebdc/assets/images/gayz-fail.png')
    };
  },
  computed: {
    ...mapGetters(['selectedOrganizationsCode'])
  },
  methods: {
    submit() {
      this.singleImgUrl = null;
      this.$refs.form.validate((valid) => {
        if (valid) {
          //日志事件点击
          _hmt.push(['_trackEvent', '信息查询','证书核验', '证书核验'])
          let params = {
            loginName: this.user.userName,
            bdcqzh: this.formData.bdcqzh,
            qydm: this.zlData.zlArea,
            zjh: this.formData.zjh,
            ysxlh: this.formData.ysxlh,
            cxrmc: this.user.name,
            cxrzjh: this.user.zjh || this.user.qyzjh
          };
          verifyBdcqzh(params)
            .then((res) => {
              if (res.success) {
                if (res.data) {
                  this.singleImgUrl = this.successImg;
                  this.$message.success('产权证核验通过，是合法证书！');
                } else {
                  this.singleImgUrl = this.failImg;
                  this.$message.error('产权证核验失败，请确认所填信息的正确性！');
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {
              this.$message.error('核验接口查询不成功！');
            });
        } else {
          this.$message('请完善表单！');
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/public.scss';
@import '~@/styles/common-variables.scss';

.progress-query {
  .form-content {
    .tip {
      margin-bottom: 60px;
      border-bottom: 1px solid #e7e7e7;

      span {
        display: block;
        height: 40px;
        width: 100px;
        line-height: 40px;
        text-align: center;
        color: #101010;
        font-weight: bold;
        border-bottom: 2px solid #ff5b24;
      }
    }

    .examples-link {
      height: 34px;
    }
  }
}
</style>
